import { render } from "./MobTerms.vue?vue&type=template&id=051f3688&scoped=true"
import script from "./MobTerms.vue?vue&type=script&lang=js"
export * from "./MobTerms.vue?vue&type=script&lang=js"

import "./MobTerms.vue?vue&type=style&index=0&id=051f3688&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-051f3688"]])

export default __exports__